import { DropdownItem } from "../../../types/observation";

/**
 * Static dropdown options for SPARC Walk categories
 */
export const selectCategoryOptions: DropdownItem[] = [
  { id: "Safety", displayText: "Safety" },
  { id: "People", displayText: "People" },
  { id: "Accuracy", displayText: "Accuracy" },
  { id: "Reliability", displayText: "Reliability" },
  { id: "Costs", displayText: "Costs" },
];
